module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-content",
    attrs: {
      "id": "document-content"
    }
  }, [_c('div', {
    staticClass: "main-width",
    style: ({
      'height': _vm.innerHeight
    })
  }, [_c('div', {
    staticClass: "side-nav",
    style: ({
      'height': _vm.sideNavHeight
    })
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "mode": "vertical",
      "default-active": "1"
    }
  }, _vm._l((_vm.functionDocument.sideNavList), function(item, index) {
    return _c('el-menu-item-group', {
      key: index,
      attrs: {
        "title": item.title
      }
    }, _vm._l((item.subTitles), function(ele, idx) {
      return _c('el-menu-item', {
        key: idx,
        attrs: {
          "index": ele.menuIndex
        },
        on: {
          "click": function($event) {
            return _vm.jump(ele.globalNo)
          }
        }
      }, [_vm._v(_vm._s(ele.title))])
    }), 1)
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.functionDocument.contentInfo), function(item, index) {
    return _c('div', {
      staticClass: "content-info"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3926f788","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Document.vue
// module id = 527
// module chunks = 1